import { render } from "./RegionAstana.vue?vue&type=template&id=f661a97e&scoped=true"
import script from "./RegionAstana.vue?vue&type=script&lang=js"
export * from "./RegionAstana.vue?vue&type=script&lang=js"

import "./RegionAstana.vue?vue&type=style&index=0&id=f661a97e&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f661a97e"]])

export default __exports__